<template>
  <div class="container-page">
    <p class="title-inner">Данные о мировых ценах</p>
    <div class="mb-16">
      <ButtonComponent
        class="mr-2"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="editCard(0)"
      >
        Создать
      </ButtonComponent>
      <ButtonComponent
        class="mr-2"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из Excel' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <div class="mb-4">
      <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
    </div>
    <div>
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Год</th>
              <th>Месяц</th>
              <th>Товар</th>
              <th>Стоимость</th>
              <th>Единица измерения</th>
              <th>Место торгов/биржа</th>
              <th></th>
              <th></th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput
                  placeholder="Год"
                  v-model="filter.year"
                  type="number"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  :select2Options="months"
                  placeholder="Выберите"
                  type="select2"
                  v-model="filter.month"
                  :select2Settings="select2Settings"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  :select2Options="parameterList"
                  placeholder="Выберите"
                  type="select2"
                  v-model="filter.parameterId"
                  :select2Settings="select2Settings"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  placeholder="От"
                  v-model="filter.costFrom"
                  type="number"
                  v-on:valueChangedDebounced="changeFilter"
                />
                <FilterInput
                  placeholder="До"
                  v-model="filter.costTo"
                  type="number"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput placeholder="" v-model="filter.unit" v-on:valueChangedDebounced="changeFilter" />
              </th>
              <th class="filter">
                <FilterInput placeholder="" v-model="filter.marketplace" v-on:valueChangedDebounced="changeFilter" />
              </th>
              <th class="filter"></th>
              <th class="filter"></th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ item.year }}</td>
              <td>{{ item.monthName }}</td>
              <td>{{ item.parameterName }}</td>
              <td>{{ formatNumber(item.cost, 1, ' ', ',') }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.marketplace }}</td>
              <td>
                <IconComponent :disabled="importInProgress" @click="editCard(item.id)" name="mode" />
              </td>
              <td>
                <IconComponent :disabled="importInProgress" @click="deleteCard(item.id)" name="delete" />
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="9">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="9">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <section>
      <ModalComponent v-model="importModal" title="Импорт файла" @close="closeModal">
        <a href="javascript:" @click="getTemplate">Скачать шаблон</a>
        <ImportModal @doimport="doImport" @close="closeModal" />
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import textMixin from '@/common/mixins/text';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ImportModal from '@/components/modals/ImportModal.vue';

  import countryApi from '@/modules/nsi/api/country';

  import IconComponent from '../../../common/ui/IconComponent.vue';
  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import Api from '../api/worldprice';

  export default {
    name: 'WorldPrice',
    components: {
      ImportModal,
      ModalComponent,
      ButtonComponent,
      FilterInput,
      DefaultFilter,
      IconComponent,
    },
    mixins: [textMixin],
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        isImportProcess: false,
        importModal: false,
        isLoading: false,

        select2Settings: Constants.select2Settings,
        countries: [],
        parameterList: [],
        filter: {},
        months: Constants.monthList,
      };
    },
    created() {
      loadFilter(this.$options.name).then((response) => {
        let filter = response;
        if (filter) {
          this.filter = filter;
        }
        this.loadDictionaries();
        this.loadPage();
      });
    },
    methods: {
      loadDictionaries() {
        countryApi.search().then((response) => {
          this.countries = [
            { text: 'Все страны', id: -1 },
            ...response.data.items.map((x) => ({ id: x.id, text: x.name })),
          ];
        });
        Utils.searchNsi('NsiWorldpriceParameter', this.defaultRequest)
          .then((response) => {
            this.parameterList = response.data;
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      loadPage(append) {
        this.isLoading = !append;
        var params = Object.assign(this.filter, this.request);
        Api.search(params)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        this.closeModal();
        this.isImportProcess = true;
        Api.uploadFile(file)
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
            this.loadPage();
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Constants.alert.fire('Импорт', 'Ошибка при импорте данных.', 'error');
          })
          .finally(() => {
            this.isImportProcess = false;
          });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      closeModal() {
        this.importModal = false;
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
      editCard(id) {
        this.$router.push({ name: 'WorldPriceCard', params: { id: id, action: 'edit' } });
      },
      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            Api.delete(id)
              .then((response) => {
                console.log(response);
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена',
                  'error',
                );
              });
          }
        });
      },
      getTemplate() {
        Api.getTemplate();
      },
    },
  };
</script>
